import { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { auth } from "../context/auth";

export default function PermissionEmp() {
    const {ActivEmp} = useContext(auth);
    if(["cashier", "delivery"].includes(ActivEmp.role)) {
        return <Navigate to={'pos'} replace />
    }

    return <Outlet />
}